<script>
import {
  templatePageMagasinEmits,
  templatePageMagasinProps,
  useTemplatePageMagasin
} from "./mixin";
import Titre from "@/components/atoms/titre";
import IconShipping from "@/components/molecules/icon-shipping";
import Button from "@/components/atoms/button";
import Badge from "@/components/atoms/badge";
import Icon from "@/components/atoms/icon";
import Divider from "@/components/atoms/divider";
import ButtonIcon from "@/components/molecules/button-icon";
import HtmlParser from "@/components/organisms/cms-container/html-parser";

export default {
  name: "FicheMagasinMobile",
  components: {
    Titre,
    IconShipping,
    Button,
    Badge,
    Icon,
    Divider,
    ButtonIcon,
    HtmlParser
  },
  props: {
    ...templatePageMagasinProps()
  },
  emits: ["openOrcloseStoreLocator", ...templatePageMagasinEmits()],
  setup(props, context) {
    const {
      ShopPageCodes,
      hasMagasin,
      horairesMagasin,
      isOpen,
      changeShop,
      getPushData
    } = useTemplatePageMagasin(props, context);

    return {
      ShopPageCodes,
      hasMagasin,
      horairesMagasin,
      isOpen,
      changeShop,
      getPushData
    };
  }
};
</script>
<template>
  <div>
    <div class="u-bgcolor-white u-mb-md u-p-sm">
      <ButtonIcon
        v-if="context==='page-article-blog'"
        link
        variant="text-light"
        icon-name="arrow-left"
        icon-color="text-light"
        icon-color-hover="primary-light"
        icon-size="xs"
        no-underline
        :to="`/magasins/${magasin.attributes.aliasWeb}-m-${magasin.id}/blog`"
      >
        Retour au blog
      </ButtonIcon>
      <ButtonIcon
        v-if="context==='hp-blog'"
        link
        variant="text-light"
        icon-name="arrow-left"
        icon-color="text-light"
        icon-color-hover="primary-light"
        icon-size="xs"
        no-underline
        :to="`/magasins/${magasin.attributes.aliasWeb}-m-${magasin.id}`"
      >
        Retour à la fiche magasin
      </ButtonIcon>
      <Divider
        v-if="context"
        dotted
      />
      <Titre
        size="md"
        tag="h1"
        class="u-mb-xs"
      >
        Cora hypermarché {{ magasin.attributes.magasin }} devient Carrefour {{ magasin.attributes.magasin }}
      </Titre>
      <p
        v-if="isOpen"
        class="u-color-success u-mb-sm u-font-17"
      >
        {{ horairesMagasin }}
      </p>
      <p
        v-else
        class="u-color-alert u-mb-sm u-font-17"
      >
        Actuellement fermé
      </p>
      <template v-if="!isPro">
        <IconShipping
          v-if="magasin.attributes.dispoPremierCreneau && magasin.attributes.dispoPremierCreneau !=='indisponible'"
          type="DRIVE"
          variant="primary"
        >
          <p class="u-font-17">
            Prochain créneau drive : <br />
            <strong class="u-font-500">{{ magasin.attributes.dispoPremierCreneau }}</strong>
          </p>
        </IconShipping>
        <IconShipping
          v-else
          type="DRIVE"
          variant="primary"
        >
          <p class="u-font-17">
            Aucun créneau drive n'est disponible pour le moment dans ce magasin.
          </p>
        </IconShipping>
      </template>
      <div class="u-text-center u-mt-md u-mb-md">
        <Button
          v-if="hasMagasin && context!=='page-article-blog' && context!=='hp-blog'"
          variant="primary"
          radius="full"
          size="sm"
          @click="changeShop(magasin.id)"
        >
          Choisir ce magasin
        </Button>
        <div
          v-else-if="context!=='page-article-blog' && context!=='hp-blog'"
          class="u-text-center"
        >
          <div class="u-inline-flex u-flex-align-center">
            <Badge
              variant="success"
              circle
              size="xs"
            >
              <Icon
                name="check"
                variant="white"
                size="xxs"
              />
            </Badge>
            <p class="u-font-13 u-ml-xs">
              Vous avez sélectionné ce magasin
            </p>
          </div>
          <Button
            v-if="context!=='page-article-blog' && context!=='hp-blog'"
            link
            variant="primary"
            @click="$emit('openOrcloseStoreLocator')"
          >
            Choisir un autre magasin
          </Button>
        </div>
      </div>
      <HtmlParser
        v-if="getPushData(ShopPageCodes.FICHE_MAGASIN_SEO_FOOTER).html_content"
        class="u-pb-sm"
        :context="`FICHE MAGASIN SEO FOOTER`"
        :content="getPushData(ShopPageCodes.FICHE_MAGASIN_SEO_FOOTER).html_content"
      />
    </div>
    <slot />
  </div>
</template>

<style lang="scss" scoped>
</style>
